var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SlideOnMobile',{staticClass:"u-marginTop3 u-marginBottom3 u-marginBottom7@tabletPortrait"},[_c('div',{staticClass:"s-quizContainer"},[_c('StartQuizSmall'),(_vm.activeQuizzes)?_vm._l((_vm.activeQuizzes),function(quiz){return _c('div',{key:quiz.id},[_c('QuizCard',{attrs:{"quiz":quiz}})],1)}):_vm._e()],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }